import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '@/components/ui.tsx';
import { AnnouncementsView } from '@/views/announcements/announcements-view.tsx';

// ADR-017: platform-wide announcements list (admin broadcasts only).
export const Route = createFileRoute('/_learner/announcements')({
  component: AnnouncementsPage,
});

function AnnouncementsPage() {
  return (
    <div className="mx-auto max-w-6xl px-6 py-10">
      <PageHeader title="Announcements" subtitle="Platform-wide notices from the school administration." />
      <div className="mt-8">
        <AnnouncementsView />
      </div>
    </div>
  );
}
